import { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { createCertification } from '../../actions/certificationActions'
import { showGenericError } from '../../utility/certificationBuilder'
import { useForm } from './useForm'
import Modal from '../common/Modal'
import Input from '../common/form/Input'
import CancelButton from '../common/buttons/CancelButton'
import SubmitButton from '../common/buttons/SubmitButton'

import classes from './CertificationFormModal.module.scss'

const CertificationFormModal = ({ isOpen, nextLevel, onClose, onCreated }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { form, errors, setErrors, setField } = useForm({ name: '', level: String(nextLevel) })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (form.name.trim() === '') { setErrors({ name: t('certificationBuilder.details.errors.name') }); return }

    setIsSubmitting(true)
    dispatch(createCertification({ name: form.name.trim(), level: Number(form.level) || nextLevel })).unwrap()
      .then(({ certification }) => onCreated(certification))
      .catch((apiErrors) => {
        apiErrors?.name || apiErrors?.level ? setErrors({ name: apiErrors.name?.[0], level: apiErrors.level?.[0] }) : showGenericError()
        setIsSubmitting(false)
      })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classes.modalContent}>
      <h2 className={classes.title}>{t('certificationBuilder.create.title')}</h2>

      <form onSubmit={handleSubmit} className={`d-flex flex-column ${classes.form}`}>
        <div className={classes.row}>
          <div>
            <label htmlFor='certificationFormName'>{t('certificationBuilder.details.title')} <span className='required-text'>*</span></label>
            <Input
              id='certificationFormName'
              type='text'
              value={form.name}
              placeholder={t('certificationBuilder.create.namePlaceholder')}
              onChange={(e) => setField('name', e.target.value)}
              error={errors.name}
            />
          </div>
          <div>
            <label htmlFor='certificationFormLevel'>{t('certificationBuilder.details.level')}</label>
            <Input
              id='certificationFormLevel'
              type='number'
              min={1}
              value={form.level}
              onChange={(e) => setField('level', e.target.value)}
              error={errors.level}
            />
          </div>
        </div>

        <div className='row pt-2'>
          <div className='col-6'>
            <CancelButton onClick={onClose} buttonMessage={t('common.cancel')} />
          </div>
          <div className='col-6'>
            <SubmitButton type='submit' buttonMessage={t('certificationBuilder.create.submit')} loading={isSubmitting} noTopMargin />
          </div>
        </div>
      </form>
    </Modal>
  )
}

CertificationFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  nextLevel: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreated: PropTypes.func.isRequired,
}

export default CertificationFormModal
